import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { BlockGuard } from '../../types/api/Block';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import {
  MembershipsByPageType,
  UserMembershipDefault,
  UserMembershipEdit,
  UserMembershipsContentList,
} from '../../_lib/components/UserMemberships';

type OrgUnitMembershipsDefault = MembershipsByPageType<{ orgunit: UserMembershipDefault[] }>;
type OrgUnitMembershipsEdit = MembershipsByPageType<{ orgunit: UserMembershipEdit[] }>;

export type OrgUnitMembershipsProps = Views<
  DefaultView<OrgUnitMembershipsDefault> & OptionalEditView<OrgUnitMembershipsEdit>
>;

function OrgUnitMemberships({ views }: OrgUnitMembershipsProps) {
  const { editModeInfo } = useAppContext();
  const editModeActive = editModeInfo.active;
  const { memberships } = editModeActive && views.edit ? views.edit.embedded : views.default.embedded;

  const orgUnitRoles = memberships?.orgunit;
  return orgUnitRoles ? <UserMembershipsContentList memberships={orgUnitRoles} /> : null;
}

export const OrgUnitMembershipsBlock = asFetchableBlock(OrgUnitMemberships, BlockType.orgunitMemberships);
export type OrgUnitMembershipsBlock = ComponentProps<typeof OrgUnitMembershipsBlock>;
export const isOrgUnitMembershipsBlock = BlockGuard<OrgUnitMembershipsBlock>(BlockType.orgunitMemberships);
